<template>
    <ContentLoader
        :height="180"
        :width="1500"
        :speed="2"
        primaryColor="#fcfcfc"
        secondaryColor="#f9f9f9"
    >
        <rect x="0" y="0" rx="5" ry="5" width="233" height="20" /> <rect x="273" y="0" rx="5" ry="5" width="233" height="20" /> <rect x="526" y="0" rx="5" ry="5" width="233" height="20" /> <rect x="779" y="0" rx="5" ry="5" width="233" height="20" /> <rect x="1032" y="0" rx="5" ry="5" width="233" height="20" /> <rect x="1285" y="0" rx="5" ry="5" width="233" height="20" />
        <rect x="0" y="40" rx="5" ry="5" width="233" height="20" /> <rect x="273" y="40" rx="5" ry="5" width="233" height="20" /> <rect x="526" y="40" rx="5" ry="5" width="233" height="20" /> <rect x="779" y="40" rx="5" ry="5" width="233" height="20" /> <rect x="1032" y="40" rx="5" ry="5" width="233" height="20" /> <rect x="1285" y="40" rx="5" ry="5" width="233" height="20" />
        <rect x="0" y="80" rx="5" ry="5" width="233" height="20" /> <rect x="273" y="80" rx="5" ry="5" width="233" height="20" /> <rect x="526" y="80" rx="5" ry="5" width="233" height="20" /> <rect x="779" y="80" rx="5" ry="5" width="233" height="20" /> <rect x="1032" y="80" rx="5" ry="5" width="233" height="20" /> <rect x="1285" y="80" rx="5" ry="5" width="233" height="20" />
        <rect x="0" y="120" rx="5" ry="5" width="233" height="20" /> <rect x="273" y="120" rx="5" ry="5" width="233" height="20" /> <rect x="526" y="120" rx="5" ry="5" width="233" height="20" /> <rect x="779" y="120" rx="5" ry="5" width="233" height="20" /> <rect x="1032" y="120" rx="5" ry="5" width="233" height="20" /> <rect x="1285" y="120" rx="5" ry="5" width="233" height="20" />
        <rect x="0" y="160" rx="5" ry="5" width="233" height="20" /> <rect x="273" y="160" rx="5" ry="5" width="233" height="20" /> <rect x="526" y="160" rx="5" ry="5" width="233" height="20" /> <rect x="779" y="160" rx="5" ry="5" width="233" height="20" /> <rect x="1032" y="160" rx="5" ry="5" width="233" height="20" /> <rect x="1285" y="160" rx="5" ry="5" width="233" height="20" />
    </ContentLoader>
</template>

<script>
    import { ContentLoader } from 'vue-content-loader'
    export default {
        name: "RequestsLoader",
        components: {ContentLoader}
    }
</script>

<style scoped>

</style>
